import { Input } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import { useCallback } from 'react';

import { useValueHandle } from '../../hook/useValueHandle';
import { FloatingLabelBox } from '../FloatingLabelBox';

const { TextArea } = Input;

export interface FloatTextAreaProps extends TextAreaProps {
  required?: boolean;
}

export function FloatTextArea({
  placeholder,
  onFocus,
  onBlur,
  onChange,
  value,
  defaultValue,
  style,
  size,
  required,
  ...restProps
}: FloatTextAreaProps) {
  const { hasValue, handleChange, handleBlur, handleFocus, isFocus } =
    useValueHandle({
      id: restProps.id,
      defaultValue,
      value,
      onFocus,
      onBlur,
    });

  const changeHandler = useCallback<
    React.ChangeEventHandler<HTMLTextAreaElement>
  >(
    (e) => {
      handleChange(e.target.value);
      if (onChange) {
        onChange(e);
      }
    },
    [onChange]
  );

  return (
    <FloatingLabelBox
      label={placeholder}
      focused={isFocus}
      haveValue={hasValue}
      width={style?.width}
      height={style?.height}
      required={required}
      status={
        restProps.status || (restProps['aria-invalid'] ? 'error' : undefined)
      }
    >
      <TextArea
        style={style}
        className="w-full border-none py-2"
        variant="borderless"
        {...restProps}
        onFocus={handleFocus}
        onBlur={handleBlur}
        value={value}
        defaultValue={defaultValue}
        onChange={changeHandler}
        size={size}
      />
    </FloatingLabelBox>
  );
}
